const React = require('react');
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import TextField from '@material-ui/core/TextField';


export class TextInputModal extends React.Component{
   constructor(props) {
      super(props);
      this.state={
         enteredText: props.defaultValue ? props.defaultValue: ''
      }
   }

   confirm(){
      this.props.confirmFunction(this.state.enteredText);
      if (this.props.closeOnConfirm) {
         this.props.closeFunction();
      }
   }

   componentDidUpdate(prevProps){
      if(prevProps.defaultValue !== this.props.defaultValue){
         this.setState({enteredText: this.props.defaultValue});
      }
   }

   render(){
      return(
         <Dialog
            open={this.props.show}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
         >
            <DialogContent>
               <DialogContentText>
                  {this.props.contentText}
               </DialogContentText>
               <TextField
                  id="textInputModalEnteredText"
                  label={this.props.label}
                  multiline
                  rowsMax="50"
                  onChange={(event) => this.setState({enteredText: event.target.value})}
                  className={''}
                  margin="normal"
                  maxLength={1000}
                  value={this.state.enteredText}
               />
            </DialogContent>
            <DialogActions>
               <Button onClick={() => this.props.closeFunction()} className={'btnTextInputModalCancel'} color="primary">
                  Cancel
               </Button>
               <Button onClick={() => {
                  if(this.props.clearOnSubmit){this.setState({enteredText: ''})}
                  this.confirm()}
                  } className={'btnTextInputModalConfirm'} color="primary" autoFocus>
                  {this.props.confirmText}
               </Button>
            </DialogActions>
         </Dialog>
      )
   }
}

TextInputModal.defaultProps = {
   closeOnConfirm: true
};